import Axios from "axios";
import { adminApi } from "../config";

const endpoint = "/print-locations";

export const listAllPrintLocations = async (params: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.get(url, {
      params,
    });
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const listPrintLocationsForForms = async () => {
  try {
    let url = `${endpoint}/for-forms`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const getPrintLocationUsageById = async (printLocationId: string) => {
  try {
    let url = `${endpoint}/${printLocationId}/usage`;
    const result = await adminApi.get(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const createPrintLocation = async (data: any) => {
  try {
    let url = `${endpoint}`;
    const result = await adminApi.post(url, data);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const updatePrintLocation = async (
  printLocationId: string,
  printLocationData: any
) => {
  try {
    let url = `${endpoint}/${printLocationId}`;
    const result = await adminApi.put(url, printLocationData);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};

export const deletePrintLocation = async (printLocationId: string) => {
  try {
    let url = `${endpoint}/${printLocationId}`;
    const result = await adminApi.delete(url);
    return result;
  } catch (err) {
    console.log(err, "err");
    if (Axios.isAxiosError(err)) {
      return err.response;
    } else {
      return null;
    }
  }
};
